import { AI_FOUNDATION_GLOSSARY } from "@/data/aiWorkflowFoundations";
import { reviseElevateLearnerCopy } from "@/data/elevateLearnerCopy";
import type { S2PElevateSlide } from "@/data/s2pElevateAI";

export const ElevateFoundations = ({ slide, learnerVoice = false }: { slide: S2PElevateSlide; learnerVoice?: boolean }) => {
  const glossary = learnerVoice ? reviseElevateLearnerCopy(AI_FOUNDATION_GLOSSARY[slide.id]) : AI_FOUNDATION_GLOSSARY[slide.id];
  return (
    <div className="mx-auto w-full max-w-6xl py-3 text-[#0A1F44] sm:py-4">
      <header className="mb-4 border-b-4 border-[#0047FF] pb-3">
        <p className="text-xs font-bold uppercase tracking-widest text-[#0047FF]">{slide.eyebrow}</p>
        <h1 className="s2p-display mt-2 text-4xl font-semibold uppercase sm:text-4xl">AI definitions</h1>
        <p className="mt-1 text-lg">{slide.lead}</p>
      </header>
      <div className="grid gap-6 md:grid-cols-2 md:gap-8">
        {glossary?.map((group) => (
          <section key={group.title} aria-label={group.title}>
            <div className="bg-[#0047FF] px-4 py-2 text-white">
              <h2 className="s2p-display text-xl font-extrabold uppercase leading-tight">{group.title}</h2>
            </div>
            <dl className="divide-y divide-[#0047FF]/20">
              {group.terms.map(({ term, definition }) => (
                <div key={term} className="px-4 py-2">
                  <dt className="text-xl font-bold leading-tight sm:text-2xl">{term}</dt>
                  <dd className="mt-1 text-base leading-snug sm:text-lg">{definition}</dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </div>
  );
};
